/**
 * Stages and Status Constants
 * Contains all stage IDs, status enums, and state-related constants
 */

export enum STAGES_IDS {
  Started = 1,
  Finalized = 2,
  Pending = 3,
  Approved = 4,
  Rejected = 5,
}

export enum STAGES {
  empty = '',
  Iniciar = 'Iniciar',
  Reanudar = 'Reanudar',
  Finalized = 'Finalized',
  Reviewing = 'Reviewing',
  success = 'success',
  NEXT = 'NEXT',
  done = 'done',
  inProgress = 'in-progress',
  notStarted = 'not-started',
  Finalizar = 'Finalizar',
  Started = 'Started',
  Valid = 'VALID',
  Send = 'Enviar',
  Cancel = 'Cancelar',
  Edit = 'Editar',
  Remove = 'Eliminar',
  Pending = 'Pending',
  AutoValoration = 'Autovaloración',
  Valoration = 'Valoración',
  Started_ESP = 'iniciada',
  Warning = 'warning',
  Exclaim = 'exclaim',
  Danger = 'danger',
  Waiting = 'waiting',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Initialize = 'Iniciar',
  Blocked = 'Blocked',
  NotApply = 'Not Apply',
}

export enum AchievementStates {
  Aproved = 1,
  Pending = 3,
  Rejected,
}

export enum Levels {
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
}

export const LEVELS_NUMBERS = {
  L1: 1,
  L2: 2,
  L3: 3,
};
